import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { capitalCase } from 'change-case';
import { useDispatch, useSelector } from 'react-redux';
import { switchModalJenjang } from 'src/redux/slices/modal';
import { chooseJenjangPendidikan } from 'src/redux/slices/jenjang';
import { useHistory } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  IconButton,
  Box,
  Tabs,
  Tab,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// import { getAllTahunAjaran } from 'src/redux/slices/tahun_ajaran';
// import { getSemester } from 'src/redux/slices/semester';
// import { getPerusahaan } from 'src/redux/slices/perusahaan';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
  },
}));

// ----------------------------------------------------------------------

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default function DashboardLayout({ children }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { modalJenjang } = useSelector((state) => state.modals);
  const chooseJenjang = useSelector((state) => state.jenjang.chooseJenjang);
  const { applications = [], user } = useAuth();
  const perusahaanReduxs = useSelector((state) => state.perusahaan.posts);
  const [open, setOpen] = useState(false);

  const [currentTab, setCurrentTab] = useState('Semua');
  const [listCategory, setListCategory] = useState([]);

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // Fungsi untuk transformasi data
  const transformData = (data = []) => {
    const uniqueCompanies = new Map();

    data.forEach((item) => {
      if (!uniqueCompanies.has(item.company_id)) {
        uniqueCompanies.set(item.company_id, {
          id: item.company_id,
          nama_perusahaan: item.company_name,
        });
      }
    });

    return Array.from(uniqueCompanies.values());
  };

  useEffect(() => {
    if (chooseJenjang) {
      if (Object.keys(chooseJenjang).length == 0) {
        dispatch(switchModalJenjang(true));
      }

      if (!chooseJenjang.company_id) {
        dispatch(switchModalJenjang(true));
      }
    } else {
      dispatch(switchModalJenjang(true));
    }

    setCurrentTab(
      user.unit && user.unit.perusahaan && user.unit.perusahaan.length > 1
        ? user.unit.perusahaan[0].id
        : 1,
    );
  }, []);

  const handleClose = () => {
    // if (Object.keys(chooseJenjang).length > 0) {
    dispatch(switchModalJenjang(false));
    // }else{
    //   history.goBack();
    // }
  };

  const goToPendidikan = (unit) => {
    let newUnit = { ...unit };
    if (unit.unit_name == 'KB') {
      newUnit['unit_id'] = 3;
      newUnit['unit_name'] = 'TK';
      newUnit['unit_type_id'] = 1;
      newUnit['company_id'] = unit.company_id;
    }
    dispatch(switchModalJenjang(false));
    dispatch(chooseJenjangPendidikan(newUnit));

    // if (unit) {
    //   dispatch(getAllTahunAjaran(unit.unit_id, unit.company_id));
    //   dispatch(getSemester(unit.unit_id, unit.company_id));
    //   dispatch(getPerusahaan(unit.company_id));
    // }

    // const getSAG = applications.find((val) => val.code == 'SAG');
    // window.location.href = getSAG.host;

    setTimeout(() => {
      const getSAG = applications.find((val) => val.code == 'SAG');
      window.location.href = getSAG.host;
    }, 1000);
  };

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <MainStyle>
        {children}
        <Dialog
          open={modalJenjang}
          maxWidth={'md'}
          onClose={handleClose}
          fullWidth
          scroll="body"
        >
          <DialogTitle
            disableTypography
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5" fontWeight="bold">
              Pilih Jenjang
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Box sx={{ m: 2 }} style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Tabs
              value={currentTab}
              scrollButtons="auto"
              variant="scrollable"
              allowScrollButtonsMobile
              onChange={handleChangeTab}
            >
              {transformData(user.unit && user.unit).map((perusahaan) => (
                <Tab
                  disableRipple
                  key={perusahaan?.id}
                  label={capitalCase(perusahaan?.nama_perusahaan ?? '')}
                  icon={''}
                  value={perusahaan?.id}
                />
              ))}
            </Tabs>
          </Box>

          <DialogContent>
            {user.unit && (
              <Stack direction="row" justifyContent="space-around">
                {user.unit
                  .filter((unit) => unit.company_id === currentTab)
                  .map((val, i) => {
                    return (
                      <Button
                        key={i}
                        size="large"
                        variant="contained"
                        color="primary"
                        sx={{ width: '24%' }}
                        onClick={() => goToPendidikan(val)}
                      >
                        {val.unit_name == 'KB' ? 'TK' : val.unit_name}
                      </Button>
                    );
                  })}
              </Stack>
            )}
          </DialogContent>
        </Dialog>
      </MainStyle>
    </RootStyle>
  );
}
